import { createFileRoute } from '@tanstack/react-router';
import { AuditsList } from '@/app/(client)/audits/-components/AuditsList';

export const Route = createFileRoute(
  '/(client)/audits/(pages)/(list)/network-audits/active/',
)({
  component: ActiveNetworkAuditsPage,
});

function ActiveNetworkAuditsPage() {
  return <AuditsList activeTab='network-audits' isArchived={false} />;
}
